import { Extension } from "@tiptap/core";

/** Stable policy-commitment identity carried by generated prose blocks. */
export const CommitmentKeyExtension = Extension.create({
  name: "commitmentKey",
  addGlobalAttributes() {
    return [
      {
        types: ["paragraph", "heading"],
        attributes: {
          commitmentKey: {
            default: null,
            parseHTML: (element) => element.getAttribute("data-commitment-key"),
            renderHTML: (attributes) =>
              attributes.commitmentKey
                ? {
                    "data-commitment-key": attributes.commitmentKey,
                  }
                : {},
          },
        },
      },
    ];
  },
});
